/* HELDENA · glasservice-kampanya galeri v1.1 · 05.09.2026

   ⚠️ DUZELTME: BITMIS KAMPANYA GERI SAYIMI CANLIDA
   gkEnd sabit 2026-08-01 yaziliydi. Tarih bir aydan fazla gecmisti, yani
   bu sablondaki her urunde musteri "Kampagne beendet" yazisini goruyordu.
   Satin almaya hazir bir musteriye "kampanya bitti" demek dogrudan satis kaybi.

   Yeni tarih Kampanya Standardi v2.0'a gore 01.10.2026.
   Sayac ayrica: tarih gecmisse artik "beendet" YAZMAZ, blogu tamamen gizler.
   Boylece bir dahaki sefere tarih guncellenmezse en fazla sayac kaybolur,
   olumsuz mesaj cikmaz.
*/
(function(){
  var root=document.getElementById('gkv1');if(!root)return;
  var main=root.querySelector('#gkMain');

  root.querySelectorAll('.gk-thumbs button').forEach(function(b){
    b.addEventListener('click',function(){
      root.querySelectorAll('.gk-thumbs button').forEach(function(x){x.classList.remove('active')});
      b.classList.add('active');
      if(main)main.src=b.getAttribute('data-src');
    });
  });

  /* Kampanya bitisi · Kampanya Standardi v2.0 */
  var gkEnd=new Date('2026-11-01T23:59:59+01:00').getTime();
  var gkCd=root.querySelector('#gkCountdown');
  if(gkCd){
    var d=gkEnd-new Date().getTime();
    if(d<=0){
      /* tarih gecmisse olumsuz mesaj gosterme - blogu gizle */
      gkCd.style.display='none';
    }else{
      var days=Math.floor(d/86400000);
      gkCd.textContent = days>1
        ? 'Noch '+days+' Tage bis Kampagnenende'
        : 'Kampagne endet heute';
    }
  }

  root.querySelectorAll('.gk-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.gk-offer').forEach(function(x){x.classList.remove('active')});
      o.classList.add('active');
      var qi=root.querySelector('#gkQtyInput');
      if(qi)qi.value=o.getAttribute('data-qty');
    });
  });

  root.querySelectorAll('.gk-q>button').forEach(function(btn){
    btn.addEventListener('click',function(){
      var q=btn.parentElement,ans=q.querySelector('.ans');
      if(q.classList.contains('open')){q.classList.remove('open');ans.style.maxHeight=null;}
      else{q.classList.add('open');ans.style.maxHeight=ans.scrollHeight+'px';}
    });
  });


  var shipping=root.querySelector('[data-gk-price]');
  function updateShipping(){if(!shipping)return;var qty=Number(root.querySelector('#gkQtyInput')?.value)||1;var subtotal=Number(shipping.dataset.gkPrice)*qty;var total=qty>=3?Math.round(subtotal*.9):subtotal;var remaining=Math.max(0,3990-total);var money=n=>(n/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'});shipping.querySelector('[data-gk-shipping-message]').textContent=remaining?'Für diese Auswahl fehlen noch '+money(remaining)+' bis zum kostenlosen Versand.':'Diese Auswahl erreicht den kostenlosen Versand.';var pct=Math.min(100,total/3990*100);shipping.querySelector('.gk-shipping-fill').style.width=pct+'%';shipping.querySelector('.gk-shipping-truck').style.left=pct+'%';}
  root.querySelectorAll('.gk-offer').forEach(function(o){o.addEventListener('click',updateShipping)});updateShipping();

  var st=root.querySelector('#gkSticky');
  if(st){
    window.addEventListener('scroll',function(){
      st.style.display = window.scrollY>700 ? 'flex' : 'none';
    },{passive:true});
  }
})();
